import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-accounting',
  imports: [RouterOutlet],
  templateUrl: './accounting.component.html',
})
export class AccountingComponent {}
